import React from 'react';
import styled from 'styled-components';
import { CellContext } from '@tanstack/react-table';
import Progress from '@hud/web-components/Progress/Progress';
import { formatPercentage } from '@hud/web-components/utils';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  max-width: 148px;
`;

export default function metricProgressCellRenderer<TData, TValue>(
  cell: CellContext<TData, TValue>,
) {
  const value = cell.getValue() as number;
  return (
    <Container>
      <LongContentPopover>{formatPercentage(value)}</LongContentPopover>
      <Progress value={value * 100} />
    </Container>
  );
}
